// extracted by mini-css-extract-plugin
export default {"container":"MultipleCompanies_container__Q4mLg","companyForm":"MultipleCompanies_companyForm__303La"};